<template>
    <div class="step-4">
        <div class="coupon-card">
            <div class="coupon-card-title">{{ $t('coupon_title') }}</div>
            <b-form class="text-center" @submit.prevent="addCoupon">
                <div class="form-group coupon-card-form-group text-center">
                    <b-form-input v-model="couponCode" type="text"
                                  class="coupon-card-input"
                                  :placeholder="`${$t('coupon_code')}`"
                                  required></b-form-input>
                    <span class="helper helper--coupon" v-if="!isMobile" v-html="$t('add_your_coupon_here')"></span>
                </div>
                <button type="submit" class="btn btn-icon-left btn-primary coupon-card-btn">
                    <span class="material-icon icon-add"></span>
                    {{ $t('add_coupon') }}
                </button>
            </b-form>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .coupon-card {
        width: 100%;
        max-width: 670px;
        margin: 0 auto;
        padding: 40px 115px 50px;
        background-color: var(--bg-color);

        &-title {
            margin-bottom: 40px;
            color: var(--text-color);
            font-size: 1.5rem;
            text-align: center;
        }

        &-form-group {
            position: relative;
        }

        &-btn {
            margin-top: 20px;
        }
    }

    body.-is-mobile {

        .coupon-card {
            padding: 30px 20px;
        }
    }
</style>

<script>
  import checkoutStep4 from 'src/mixins/checkoutStep4Component';

  export default {
    mixins: [checkoutStep4],
  };
</script>